import { render } from "./author.vue?vue&type=template&id=1fd75352"
import script from "./author.vue?vue&type=script&lang=js"
export * from "./author.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__